const maxPerPage = 1000000;

export { maxPerPage };
